import styled from "styled-components";

import { Box } from "@braze/beacon-core";
import { getSpacing } from "@braze/beacon-styling";

import { BrazeButton } from "@components/BrazeButton";

export const PhoneNumberInput = styled(Box)`
  flex: 1 1 auto;
`;

export const CodeVerificationButton = styled(BrazeButton)`
  margin-bottom: ${getSpacing("sm")};
`;
